import { render, staticRenderFns } from "./EditPartnerDialog.vue?vue&type=template&id=ec7998bc&scoped=true&lang=pug&"
import script from "./EditPartnerDialog.vue?vue&type=script&lang=ts&"
export * from "./EditPartnerDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EditPartnerDialog.vue?vue&type=style&index=0&id=ec7998bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7998bc",
  null
  
)

export default component.exports